/* eslint-disable react/forbid-prop-types */
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';

import PurchaseMethodsModel from 'commons-vehicle/PurchaseMethods/models/PurchaseMethodsModel.js';
import VehicleTitle from 'commons-vehicle/Vehicle/components/Overview/VehicleTitle/VehicleTitle.jsx';
import TileTag from 'commons-vehicle/Vehicle/components/TileTag/TileTag.jsx';
import PaymentDetail from 'commons-vehicle/Vehicle/components/Payment/PaymentDetail/PaymentDetail.jsx';
import PaymentDetailV2 from 'commons-vehicle/Vehicle/components/PaymentV2/PaymentDetail/PaymentDetail.jsx';

import 'commons-vehicle/Vehicle/components/Overview/Overview.scss';

const VehicleSummary = ({
    isUsed,
    optionalButton,
    packageName,
    purchaseMethods,
    taxCodes,
    taxesDisclaimer,
    title,
    vehicleStockNo,
    isReserved,
    vehicleVinNo,
    optionalDemoTag,
    includedDealerIncentives,
}) => {
    return (
        <div className="vehicle-overview">
            <TileTag
                shouldRender={isReserved}
                icon="icon-lock"
                background="#F5273F"
                color="#fff"
                text={LocaleService.t('VEHICLE_STATUS.RESERVED')}
            />
            {optionalDemoTag && <div className="demo-tag">{LocaleService.t('VEHICLE_STATUS.DEMO_TAG')}</div>}
            <VehicleTitle
                title={title}
                packageName={packageName}
                vehicleStockNo={vehicleStockNo}
                vehicleVinNo={vehicleVinNo}
            />
            {purchaseMethods instanceof PurchaseMethodsModel ? (
                <PaymentDetailV2
                    purchaseMethods={purchaseMethods}
                    isUsed={isUsed}
                    taxCodes={taxCodes}
                    taxesDisclaimer={taxesDisclaimer}
                    includedDealerIncentives={includedDealerIncentives}
                />
            ) : (
                <PaymentDetail
                    purchaseMethods={purchaseMethods}
                    isUsed={isUsed}
                    taxCodes={taxCodes}
                    taxesDisclaimer={taxesDisclaimer}
                    includedDealerIncentives={includedDealerIncentives}
                />
            )}
            {optionalButton}
        </div>
    );
};

VehicleSummary.defaultProps = {
    isUsed: false,
    isReserved: false,
    packageName: '',
    vehicleStockNo: '',
    optionalButton: noop,
    vehicleVinNo: '',
    optionalDemoTag: false,
    includedDealerIncentives: false,
    taxesDisclaimer: '',
    purchaseMethods: new PurchaseMethodsModel(),
};

VehicleSummary.propTypes = {
    isUsed: PropTypes.bool,
    optionalButton: PropTypes.func,
    packageName: PropTypes.string,
    vehicleStockNo: PropTypes.string,
    purchaseMethods: PropTypes.shape({
        cashPurchase: PropTypes.object.isRequired,
        financing: PropTypes.object.isRequired,
    }),
    taxCodes: PropTypes.string.isRequired,
    taxesDisclaimer: PropTypes.string,
    title: PropTypes.string.isRequired,
    isReserved: PropTypes.bool,
    vehicleVinNo: PropTypes.string,
    optionalDemoTag: PropTypes.bool,
    includedDealerIncentives: PropTypes.bool,
};

VehicleSummary.displayName = 'VehicleSummary';

export default VehicleSummary;
